<div class="slack-delivery-heading">
  <capra-icon class="align-md-icon" icon="illo-mini-slack"></capra-icon>
  <h3 class="subheading">Slack settings</h3>
</div>

<dl class="slack-workspace">
  <dt class="bold">Workspace:</dt>
  <dd>
    <a
      target="_blank"
      href="{{ slackChannelDetails.slackAppUrl }}"
      rel="noreferrer noopener"
      data-test="slack-workspace"
      >{{ slackChannelDetails.slackAppTeamName }}</a
    >
  </dd>
</dl>

<section class="channel">
  <div class="form-field" [formGroup]="slackForm">
    <div class="label-container">
      <label class="mode-label channel-label" for="channels"> Channel </label>
      <span class="channel-limit"> Displays up to 100 channels </span>
    </div>
    <div class="input-container">
      <span class="leading-input-hash">#</span>
      <input
        [matAutocomplete]="auto"
        class="mode-input"
        id="channels"
        placeholder="Search..."
        formControlName="channel"
        data-test="slack-channel-selection"
        [maxLength]="80"
      />
      <capra-icon class="search-icon" icon="icon-search"> </capra-icon>
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayChannelName" data-test="channel-options">
        <mat-option *ngFor="let channel of filteredChannels$ | async" [value]="channel">
          {{ channel.channelName }}
        </mat-option>
      </mat-autocomplete>
    </div>
    <p *ngIf="channelControl.errors?.invalidText; else showHelpText" class="channel-text-error">
      Slack channel names can't contain spaces, periods, or most punctuation.
    </p>

    <ng-template #showHelpText>
      <p>
        To share in private channels, the &#64;{{appName}} app must be a member of the channel. For security, private channels
        do not appear in the list and must be typed.
      </p>
    </ng-template>
  </div>
</section>
